import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectNotFoundErrorFlagTitle: {
		id: 'software-reports-overview-page.project-not-found-error-flag-title',
		defaultMessage: 'Project not found',
		description: 'Error flag title when the request fails because the project was not found.',
	},
	projectNotFoundErrorFlagMessage: {
		id: 'software-reports-overview-page.project-not-found-error-flag-message',
		defaultMessage:
			"You tried to access a project that doesn't exist, or that you don't have permission to access. Speak to your Jira admin or Project admin to get access.",
		description:
			'Error flag message when the request fails because the project was not found or user does not have permissions to view it.',
	},
});
